import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const points = [
  "Conservation du tablier existant : pas besoin de changer les lames",
  "Le coffre est réutilisé, seul le moteur est ajouté dans l'axe",
  "Aucune modification structurelle de la baie nécessaire",
  "Pose rapide : une à deux heures par volet en moyenne",
  "Moins coûteux qu'un remplacement complet du volet",
  "Solution écologique : on réutilise l'existant au lieu de le jeter",
];

export default function SansRemplacer() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative rounded-xl overflow-hidden border border-brand-border">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Technician%20installing%20a%20Somfy%20tubular%20motor%20inside%20an%20existing%20roller%20shutter%20box%20without%20changing%20the%20white%20slats%20showing%20the%20motor%20only%20addition%20in%20a%20clean%20French%20home%20workshop%20bright%20lighting%20warm%20neutral%20tones%20professional%20photography&width=700&height=520&seq=elec-sansrempl&orientation=landscape" alt="Moteur Somfy installé sans changer le tablier du volet roulant" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>

          <div>
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-5">
              Sans remplacer tout le volet
            </h2>
            <p className="text-brand-text text-base leading-relaxed mb-5">
              L'électrification Somfy a l'avantage majeur de conserver votre volet existant. Le tablier, les lames, les coulisses et le coffre sont réutilisés tels quels. Seul le moteur tubulaire est ajouté dans l'axe, en remplacement de l'organe de manœuvre manuel. Cette approche est plus rapide, moins coûteuse et plus respectueuse de l'environnement qu'un remplacement complet du volet.
            </p>
            <p className="text-brand-text text-base leading-relaxed mb-6">
              Nos techniciens vérifient au préalable que le coffre dispose d'un espace suffisant pour accueillir le moteur, et que le tablier est en bon état. Si le volet est usé, déformé ou si les coulisses sont endommagées, nous vous en informons et proposons une solution adaptée. Dans la majorité des cas, l'électrification se déroule sans complication et vous permet de profiter immédiatement du confort électrique sans déranger votre intérieur.
            </p>
            <ul className="space-y-3">
              {points.map((point) => (
                <li key={point} className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-brand-cyan/10 shrink-0 mt-0.5">
                    <i className="ri-check-line text-brand-cyan text-sm"></i>
                  </span>
                  <span className="text-brand-text text-base">{point}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}